import gsap from 'gsap'

export default () => {

  const s = {}
  s.selector = 'slide-block';
  s.wrapSelector = `${s.selector}-wrapper`;
  s.defOpt = {
    start: {
      top: '100%',
      left: '100%'
    },
    end: {
      top: '0%',
      left: '0%'
    },
    duration: 1.5,
    delay: 0,
    onComplete: () => {}
  };
  s.animEndPromise = new Promise(resolve => s.resolver = resolve);

  const init = (element, opt = s.defOpt) => {
    s.root = element;
    s.option = Object.assign({}, s.defOpt, opt);
    _setInnerWrapEle(s.root);
    s.root.classList.add(s.selector);

    buildTween();
  }
  const buildTween = () => {
    const startOption = {
      opacity: 0,
      x: s.option.start.left,
      y: s.option.start.top,
      ease: s.option.ease ? s.option.ease : 'none'
    }
    s.addedOptions = Object.keys(s.option.start).filter(key => !['top', 'left'].includes(key))
    s.addedOptions.forEach(key => startOption[key] = s.option.start[key]);
    s.tween = gsap.set(s.innerWrap, startOption);
  }

  const move = () => {
    const endOption = {
      opacity: 1,
      x: s.option.end.left,
      y: s.option.end.top,
      duration: s.option.duration,
      delay: s.option.delay,
      onComplete: () => {
        s.option.onComplete();
        s.innerWrap.removeAttribute('style');
        s.resolver();
      }
    }
    s.addedOptions.forEach(key => endOption[key] = s.option.end[key] || 0);
    gsap.to(s.innerWrap, endOption);
  }

  const _setInnerWrapEle = (element) => {
    const innerContent = element.firstElementChild;

    s.innerWrap = document.createElement('div');
    s.innerWrap.classList.add(s.wrapSelector)

    s.innerWrap.appendChild(innerContent);
    element.appendChild(s.innerWrap);
  }

  return {
    init,
    move,
    animEndPromise: s.animEndPromise
  }
}
